import {
	frappeMethodService,
	normalDate,
	setPageLoading,
	formatErrorMessage,
	setSubscriptionPlan,
	clearSubscriptionPlan,
	SET_MESSAGE,
	ERROR_MSG,
} from "../../packages";

export const refreshSubscriptionPlan = async (
	dispatch: any,
	showLoader = false
) => {
	try {
		if (showLoader) {
			dispatch(setPageLoading({ loading: true, loadingText: "Loading..." }));
		}

		const [planRes, creditsRes] = await Promise.all([
			frappeMethodService(
				"credit_based_costing.api.pricing_plans.get_plan_detials",
				{},
				""
			),
			frappeMethodService(
				"extractor_costing_frappe_app.api.feedback.get_feedback_credit_info",
				{},
				""
			),
		]);

		const planName = planRes?.data?.plan_name || "Free Plan";
		const totalLimit = planRes?.data?.total_fileupload_limit || 0;
		const availableLimit = planRes?.data?.avaliable_fileupload_limit || 0;

		const usedUploads = totalLimit - availableLimit;
		const allocatedUploads = totalLimit;

		const credits = creditsRes.data.message?.total_credits_gained ?? 0;
		const credit_gain_per_feedback =
			creditsRes.data.message?.credit_gain_per_feedback;
		const total_feedback_given = creditsRes.data.message?.total_feedback_given;
		const feedbackCreditConfigDoc = creditsRes.data.message?.doc_name;

		dispatch(
			setSubscriptionPlan({
				plan: planName,
				used_file_uploads: usedUploads < 0 ? 0 : usedUploads,
				allocated_file_uploads: allocatedUploads,
				plan_status: planRes?.data?.bool_value ? "Activated" : "Expired",
				plan_expiry_date: normalDate(planRes?.data?.plan_expiry_on) || "",
				credits,
				total_feedback_given,
				credit_gain_per_feedback,
				feedbackCreditConfigDoc,
			})
		);

		return {
			credits,
			total_feedback_given,
			credit_gain_per_feedback,
			feedbackCreditConfigDoc,
		};
	} catch (error: any) {
		dispatch(clearSubscriptionPlan());
		dispatch({
			type: SET_MESSAGE,
			payload: { case: ERROR_MSG, data: formatErrorMessage(error) },
		});
		throw error;
	} finally {
		if (showLoader) {
			dispatch(setPageLoading({ loading: false, loadingText: "" }));
		}
	}
};
